// ————————————————————————————————————————————————
// Protech Future System Sdn Bhd — content inventory
// 100% preserved from the original website
// (protechfuture.net: Home, About, Service, Contact Us)
// ————————————————————————————————————————————————

export const COMPANY = {
  legalName: "PROTECH FUTURE SYSTEM SDN BHD",
  shortName: "Protech Future System",
  incorporated: "2016",
  tagline: "We are an innovative cyber security related solutions provider.",
  incorporation: "Protech Future System Sdn Bhd was incorporated in 2016.",
  email: "support@protech.net",
  phoneDisplay: "+603 2022 1177",
  phoneHref: "tel:+60320221177",
};

export const NAV_LINKS = [
  { label: "Home", path: "/", testId: "nav-link-home" },
  { label: "About", path: "/about", testId: "nav-link-about" },
  { label: "Services", path: "/service", testId: "nav-link-services" },
  { label: "Contact Us", path: "/contact-us", testId: "nav-link-contact" },
];

// Original Service page — category "CyberSecurity"
export const CYBERSECURITY_SERVICES = [
  {
    num: "01",
    name: "Secure Configuration",
    desc: "Removal of or disabling of redundant functionality from systems.",
    icon: "settings",
  },
  {
    num: "02",
    name: "Network Security",
    desc: "Decrease the chances of existing systems and technologies being attacked by developing, etc.",
    icon: "network",
  },
  {
    num: "03",
    name: "Malware Prevention",
    desc: "Cover any code or content that could have a malicious, adverse impact on systems.",
    icon: "bug",
  },
];

// Original Service page — category "Mobile Privacy Protection"
export const MOBILE_PRIVACY_SERVICES = [
  {
    num: "04",
    name: "Cloud Auto Response",
    desc: "Collect information about the application and record useful permission list into intelligent database.",
    icon: "cloud-cog",
  },
  {
    num: "05",
    name: "Cloud Base System",
    desc: "Set permission list and data to consume the over privileged applications.",
    icon: "cloud",
  },
  {
    num: "06",
    name: "Encryption Data",
    desc: "AES Block ciphers are used for our encryption data.",
    icon: "lock",
  },
];

// Original About page
export const PILLARS = [
  {
    num: "01",
    title: "Mission",
    text: "Our mission is to empower individuals and organizations by providing cutting-edge cybersecurity solutions tailored for portable devices, including Android and iOS platforms.",
  },
  {
    num: "02",
    title: "Vision",
    text: "We aspire to be at the forefront of research and development, continuously exploring new approaches and technologies to address the ever-changing cybersecurity landscape.",
  },
  {
    num: "03",
    title: "Value",
    text: "Products are designed to secure and protect client privacy and security of an individual or organization with the help of free applications design to work in a different environment on little subscription fees.",
  },
];

// Original About page — "Why Choose Us"
export const WHY_POINTS = [
  { num: "01", title: "International Market Presence" },
  { num: "02", title: "Financial Stability" },
  { num: "03", title: "High-Performance Servers" },
  { num: "04", title: "24-Hour Support" },
];

export const WHY_INTRO =
  "Offers international market presence, financial stability, high-performance servers, and 24-hour support.";
export const WHY_COMMITMENT =
  "With our unwavering commitment to excellence and customer satisfaction, we are ready to safeguard your digital future.";

// Marquee — existing service & technology terms only
export const MARQUEE_ITEMS = [
  "Cyber Security",
  "Secure Configuration",
  "Network Security",
  "Malware Prevention",
  "Mobile Privacy Protection",
  "Cloud Auto Response",
  "Cloud Base System",
  "Encryption Data",
  "AES Block Ciphers",
];

export const IMAGES = {
  shieldCore:
    "https://static.prod-images.emergentagent.com/jobs/357356a7-65e6-460d-95c6-1d310db5471d/images/55d24f7f191060736d73ff583022239e0c0e9b52537c6d8e568a5d846fe8d234.jpeg",
  shield:
    "https://static.prod-images.emergentagent.com/jobs/357356a7-65e6-460d-95c6-1d310db5471d/images/59f45a086f10ef2ec0f7aeb685a75664da86a73dd631e761692c7116e17e7630.jpeg",
  mobile:
    "https://static.prod-images.emergentagent.com/jobs/357356a7-65e6-460d-95c6-1d310db5471d/images/79bf22899f9413ef2a465eb779bf9bfda8b8a3d0afdda5957eafa7ed1be6d409.jpeg",
  server:
    "https://images.pexels.com/photos/37605913/pexels-photo-37605913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  abstract:
    "https://images.unsplash.com/photo-1765410850770-7d7bc8928f17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGRpZ2l0YWwlMjBzZWN1cml0eSUyMG5ldHdvcmslMjBkYXJrJTIwYmx1ZSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzg5NzkwNjc3fDA&ixlib=rb-4.1.0&q=85",
  dots:
    "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGRpZ2l0YWwlMjBuZXR3b3JrfGVufDB8fHx8MTc4OTc5MDI5NXww&ixlib=rb-4.1.0&q=85",
};
